import React from 'react';
import parse from 'html-react-parser';
import { Button } from 'react-bootstrap';
import './Show.scss';
import { useStateValue } from '../../../utilities/StateProvider';

export default function Show(props) {

    const [{ cart, isInterior }, dispatch] = useStateValue();

    const hasCooler = Number(props.data.meta.cooler);

    const toggleModal = () => {
        props.setModal(true);
    }

    const addToCart = () => {
        const { show } = cart;

        const newCart = {
            ...cart,
            show: {
                ...show,
                price: props.data.meta.price,
                priceInterior: props.data.meta.price_interior,
                name: props.data.title.rendered,
                content: props.data.content.rendered,
                quantity: 1,
            }
        }
        
        sessionStorage.setItem('cart', JSON.stringify(newCart));

        dispatch({
            type: 'setCart',
            cart: newCart
        });
    }

    return (
        <React.Fragment>
            <div>
                <div className="show-title">{props.data.title.rendered}</div>
                <div className="show-description">
                    {parse(props.data.content.rendered)}
                </div>
            </div>
            <div className="show-buttons">
                {!!hasCooler && <div className="show-cooler-button" onClick={toggleModal} />}
                <div className="price">{`$${!isInterior ? props.data.meta.price : props.data.meta.price_interior}`}</div>
                <div><Button className="shop-button" onClick={addToCart}>Agregar<br/>al carrito</Button></div>
            </div>
        </React.Fragment>
    )
}
